import { getInitials } from '@tempo-io/string-util';
import { Avatar, AvatarFallback } from '@tempo-io/sui-avatar';
import { cn } from '@tempo-io/sui-class-utils';

type UserAvatarProps = {
  name?: string;
  email?: string;
  className?: string;
  size?: 'sm' | 'md' | 'lg';
};

const UserAvatarColors = [
  'bg-bg-accent-red',
  'bg-bg-accent-violet',
  'bg-bg-accent-yellow',
  'bg-bg-accent-teal',
  'bg-bg-accent-rose',
  'bg-bg-accent-cyan',
  'bg-bg-accent-lime',
] as const;

const getStringNumericalValue = (inputString: string): number => {
  let numericalValue = 0;
  for (let i = 0; i < inputString.length; i++) {
    numericalValue += inputString.charCodeAt(i);
  }
  return numericalValue;
};

const getUserInitials = (name: string | undefined, email: string | undefined) => {
  if (name === 'Admin' || email?.includes('@deleted.contact')) return '';

  const nameInitials = getInitials(name);
  if (nameInitials) return nameInitials;

  return email?.charAt(0).toUpperCase() ?? '';
};

export const UserAvatar = ({ name, email, className, size = 'sm' }: UserAvatarProps) => {
  const initial = getUserInitials(name, email);
  const value = getStringNumericalValue(`${name}${email}`);
  const colorIndex = value % UserAvatarColors.length;
  const avatarColorClass = UserAvatarColors[colorIndex];

  return (
    <Avatar size={size} className={className}>
      <AvatarFallback className={cn(initial ? avatarColorClass : '')}>{initial}</AvatarFallback>
    </Avatar>
  );
};
